import {get,post, del} from '@/axios'
export const login = p =>post('/login/user',p);
export const logout = p =>del('/login/logout');
export const getInfo = p =>get('/user/info',p);


// WEBPACK FOOTER //
// ./src/api/login.js